import React from 'react'
import { View } from 'react-native'
import { GameModal } from '../../../screens/GameContainer/Modals/GameModalContainer'
import { AddBotsContent, type AddBotsContentProps } from './AddBotsContent'

type AddBotsModalProps = AddBotsContentProps & {
  visible: boolean
}

// biome-ignore format: for readability
export function AddBotsModal({
  visible,
  isSubmitting = false,
  onClose,
  ...rest
}: AddBotsModalProps) {
  return (
    // Negative vertical offset so large dialogs reveal Add|Cancel buttons above BottomSheets
    <GameModal verticalOffset={-130} visible={visible} onClose={isSubmitting ? () => {} : onClose}>
      <View style={{ padding: 20 }}>
        {/* biome-ignore format: for readability */}
        <AddBotsContent
          isSubmitting={isSubmitting}
          onClose={onClose}
          {...rest}
        />
      </View>
    </GameModal>
  )
}
